/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesGoCampaign_Counties.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for GoCampaign County Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Saturday, October 26, 2019 - 03:25:47 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      10/26/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const GoCampaign_CountyList = Loadable({
    loader: () => import('../containers/GoCampaign_Counties/GoCampaign_CountyListContainer'),
    loading: Loading,
});

export const GoCampaign_CountyForm = Loadable({
    loader: () => import('../containers/GoCampaign_Counties/GoCampaign_CountyEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesGoCampaign_Counties.js